import {SET_MAINTENANCE} from 'redux/actionTypes'

export const setMaintenance = (payload) => {
  return {
    type: SET_MAINTENANCE,
    payload,
  }
}
